import { BorderedBoxEntry } from "pages/LessonRecord/components";
import { Row, Col, Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useMemo } from "react";
import ReactRoundedImage from "react-rounded-image";
import apiService from "services/api";

const getStudentNFTID = (nftPath) => {
  if (!nftPath) return null;
  return nftPath
    .replace("https://d2di15sl6tvw64.cloudfront.net/optimized/", "")
    .replace("_optimized.webp", "");
};

const StudentDetailTab = ({ id, student }) => {
  const history = useHistory();
  const nftId = getStudentNFTID(student?.nftPath);
  const tokenPrepend = useMemo(() => {
    return `?token=${apiService.auth.token.get()}`;
  }, []);

  return (
    <Row>
      <div className="col-12 d-flex align-items-end flex-column">
        <Button
          color="warning"
          size="sm"
          onClick={() => history.push(`/student/edit/${student?.id}`)}
        >
          Edit
        </Button>
      </div>
      <Col sm="12">
        <div className="row">
          <div className="col-12 d-flex" style={{ columnGap: 12 }}>
            {student?.nftPath && (
              <ReactRoundedImage
                image={student?.nftPath}
                roundedSize="1"
              ></ReactRoundedImage>
            )}
            {student?.imgPath && (
              <ReactRoundedImage
                image={student?.imgPath + tokenPrepend}
                roundedSize="1"
              ></ReactRoundedImage>
            )}
          </div>

          <BorderedBoxEntry
            label="Name"
            color="info"
            value={student?.firstName + " " + student?.lastName}
          />
          <BorderedBoxEntry
            label="Head Teacher"
            color="info"
            value={
              student?.headTeacher?.fullName || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Parent"
            color="info"
            value={student?.parent?.firstName + " " + student?.parent?.lastName}
          />
          <BorderedBoxEntry
            label="Centre"
            color="info"
            value={
              student?.centre ? (
                student?.centre?.longName
              ) : (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Age"
            color="info"
            value={student?.age || <span className="text-muted">None</span>}
          />
          <BorderedBoxEntry
            label="Car Number Plate 1"
            color="info"
            value={
              student?.carNumber1 || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Car Number Plate 2"
            color="info"
            value={
              student?.carNumber2 || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="DOB"
            color="info"
            value={
              student?.dob ? (
                moment(student.dob).format("DD, MMM YYYY")
              ) : (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Birthday"
            color="info"
            value={
              student?.birthday ? (
                moment(student.birthday).format("DD, MMM YYYY")
              ) : (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Email"
            color="info"
            value={student?.email || <span className="text-muted">None</span>}
          />
          <BorderedBoxEntry
            label="Primary Language"
            color="info"
            value={
              student?.primaryLanguage || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Current School"
            color="info"
            value={
              student?.currentSchool || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Current Grades"
            color="info"
            value={
              student?.currentGrades || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Public Exams to be taken"
            color="info"
            value={
              student?.publicExams || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Personality Type"
            color="info"
            value={
              student?.personalityType || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Parent's Special Request"
            color="info"
            value={
              student?.parentSpecialRequest || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Allergies"
            color="info"
            value={
              student?.allergies || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Favourite Subjects"
            color="info"
            value={
              student?.favouriteSubjects || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Least Favourite Subjects"
            color="info"
            value={
              student?.leastFavouriteSubjects || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Colour"
            color="info"
            value={
              student?.favouriteColour || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Food"
            color="info"
            value={
              student?.favouriteFood || <span className="text-muted">None</span>
            }
          />
          <BorderedBoxEntry
            label="Favourite Animal"
            color="info"
            value={
              student?.favouriteAnimal || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Hobby"
            color="info"
            value={
              student?.favouriteHobby || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Video Games"
            color="info"
            value={
              student?.favouriteVideoGames || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Movies"
            color="info"
            value={
              student?.favouriteMovies || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="Favourite Sports"
            color="info"
            value={
              student?.favouriteSport || (
                <span className="text-muted">None</span>
              )
            }
          />
          <BorderedBoxEntry
            label="NFT"
            color="info"
            value={nftId || <span className="text-muted">None</span>}
          />
        </div>
        <div className="row">
          <BorderedBoxEntry
            label="Additional Info"
            color="info"
            value={
              student?.additionalInfo || (
                <span className="text-muted">None</span>
              )
            }
          />
        </div>
      </Col>
    </Row>
  );
};

export default StudentDetailTab;
